import React from 'react';
import { formatPnL } from '../utils/stats';

export default function SummaryCard({ exchangeLabel, positions = [], exchangeData, stats }) {
  const balance = exchangeData?.total_balance ?? 0;
  const marginUsed = exchangeData?.total_initial_margin || stats?.totalMargin || 0;
  const marginProgress = balance > 0 ? Math.min(100, (marginUsed / balance) * 100) : 0;
  const progressColor = marginProgress > 80 ? '#666' : marginProgress > 60 ? '#555' : '#444';

  return (
    <div className="summary-card">
      <div className="summary-card-header">
        <h3>{exchangeLabel}</h3>
        {stats && (
          <div className={`yield-badge ${stats.fundingPercentYearly >= 0 ? 'positive' : 'negative'}`}>
            Yield: {stats.fundingPercentYearly >= 0 ? '+' : ''}{stats.fundingPercentYearly.toFixed(2)}%
          </div>
        )}
      </div>
      <div className="balance-section">
        <div className="balance-label">Balance:</div>
        <div className="balance-value">${balance.toFixed(2)}</div>
        <div className="margin-progress-bar">
          <div
            className="margin-progress-fill"
            style={{
              width: `${marginProgress}%`,
              backgroundColor: progressColor,
            }}
          />
        </div>
        <div className="margin-label">Margin: {marginProgress.toFixed(2)}% used</div>
      </div>
      <div className="metrics-grid">
        <div className="metric-item">
          <div className="metric-label">Unrealized PnL</div>
          <div className={`metric-value ${(stats?.totalUnrealizedPnl ?? 0) >= 0 ? 'positive' : 'negative'}`}>
            {formatPnL(stats?.totalUnrealizedPnl ?? 0)}
          </div>
        </div>
        <div className="metric-item">
          <div className="metric-label">Total PnL</div>
          <div className={`metric-value ${(stats?.totalPnL ?? 0) >= 0 ? 'positive' : 'negative'}`}>
            {formatPnL(stats?.totalPnL ?? 0)}
          </div>
        </div>
        <div className="metric-item">
          <div className="metric-label">Agg. Funding</div>
          <div className={`metric-value ${stats?.totalFunding >= 0 ? 'positive' : 'negative'}`}>
            {formatPnL(stats?.totalFunding ?? 0, 3)}
          </div>
        </div>
        <div className="metric-item">
          <div className="metric-label">{positions.length} Positions</div>
        </div>
      </div>
    </div>
  );
}
